
import { Component } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { BaseWidgetComponent } from '../../../../../shared/base.component'
import { PointOfInterest } from '../../map-overlay-outlet/map-overlay-outlet.component';

@Component({
    selector: 'map-pin',
    template: `<div class="map-pin" widget>
    <div class="pin">
        <svg version="1.1" xmlns="http:// www.w3.org/2000/svg" xmlns:xlink="http:// www.w3.org/1999/xlink" x="0px"
            y="0px" viewBox="0 0 53 65.7" style="enable-background:new 0 0 53 65.7;" xml:space="preserve">
            <g>
                <circle [style.fill]="context.data?.fore || '#FFFFFF'" cx="27.6" cy="21.8" r="13.1" />
                <path [style.fill]="context.data?.back || '#DC6900'" [style.stroke]="context.data?.fore || '#FFFFFF'" stroke-width="2.5"
                    stroke-miterlimit="10" d="M27.6,4c9.9,0,18,8.1,18,18s-17.1,38.2-18,39.6c-0.9-1.5-18-29.7-18-39.6S17.7,4,27.6,4z M27.6,32.8 c6,0,10.8-4.8,10.8-10.8s-4.8-10.8-10.8-10.8S16.8,16,16.8,22S21.6,32.8,27.6,32.8" />
            </g>
        </svg>
    </div>
    <div class="details" *ngIf="context.data && context.data.text">
        {{ context.data?.text }}
    </div>
</div>
`,
    styles: [`.map-pin{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:1px;width:1px;pointer-events:none}.map-pin *{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pin{position:absolute;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:2.5em;height:3em;-webkit-animation:.3s ease-out enter;animation:.3s ease-out enter}.details{position:absolute;bottom:3.8em;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:#fff;padding:.5em .75em;border-radius:.2em;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);min-width:5em;white-space:nowrap;text-align:center;-webkit-animation:.6s ease-out enter-delay;animation:.6s ease-out enter-delay}@-webkit-keyframes enter{0%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}@keyframes enter{0%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}@-webkit-keyframes enter-delay{0%,50%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}@keyframes enter-delay{0%,50%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}`],
    animations: [
        trigger('show', [
            transition(':enter', [
                style({ transform: 'translate(-50%, -100%)', opacity: 0 }),
                animate(300, style({ transform: 'translate(-50%, 0%)', opacity: 1 })),
            ]),
            transition(':leave', [style({ opacity: 1 }), animate(300, style({ opacity: 0 }))]),
        ]),
    ],
})
export class MapPinComponent extends BaseWidgetComponent {
    public context: PointOfInterest

    constructor(context: PointOfInterest) {
        super();
        this.context = context;
        console.log('Context:', context.data);
    }
}
